export interface NgShortcutConfig {
  id: string;
  key: string;
  ctrlKey?: boolean;
  altKey?: boolean;
  shiftKey?: boolean;
  preventDefault?: boolean;
}

export interface NgShortcutOptions {
  priority?: number;
  ctrlKey?: boolean;
  altKey?: boolean;
  shiftKey?: boolean;
  preventDefault?: boolean;
}

export class NgShortcut {
  private _key: string;
  private _action: () => void;
  private _priority = 0;
  private _ctrlKey?: boolean;
  private _altKey?: boolean;
  private _shiftKey?: boolean;
  private _preventDefault?: boolean;

  constructor(
    key: string,
    action: any,
    options?: NgShortcutOptions
  ) {
    this._key = key;
    this._action = action;
    this._priority = options && options.priority ? options.priority : 0;
    if (options) {
      this._ctrlKey = options.ctrlKey;
      this._altKey = options.altKey;
      this._shiftKey = options.shiftKey;
      this._preventDefault = options.preventDefault;
    }
  }

  get key(): string {
    return this._key;
  }
  set key(value: string) {
    this._key = value;
  }

  get priority(): number {
    return this._priority;
  }
  set priority(value: number) {
    this._priority = value;
  }

  get action(): any {
    return this._action;
  }
  set action(value: any) {
    this._action = value;
  }

  get ctrlKey(): boolean | undefined {
    return this._ctrlKey;
  }
  set ctrlKey(value: boolean | undefined) {
    this._ctrlKey = value;
  }

  get altKey(): boolean | undefined {
    return this._altKey;
  }
  set altKey(value: boolean | undefined) {
    this._altKey = value;
  }

  get shiftKey(): boolean | undefined {
    return this._shiftKey;
  }
  set shiftKey(value: boolean | undefined) {
    this._shiftKey = value;
  }

  get preventDefault(): boolean | undefined {
    return this._preventDefault;
  }
  set preventDefault(value: boolean | undefined) {
    this._preventDefault = value;
  }
}
